import axiosInstance from "./axiosInstance";
import { API_ENDPOINTS } from "./endpoints";

export const searchLogs = async (page: Number, size: Number, keyword: string, searchType: string) => {
  try {
    // const response = await axiosInstance.get(`${API_ENDPOINTS.log}?page=${page}&size=${size}&${searchType}=${keyword}`);
    const response = await axiosInstance.get(`${API_ENDPOINTS.log}?page=${page}&size=${size}`);
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "팀 채널 유저 검색에 실패하셨습니다.")
    console.log(error, "조건 상세 설정 유저 검색 실패!");
  }
};
